export function getWorkTaskId() {
    // eslint-disable-next-line no-underscore-dangle
    return window.__NEXT_WORKTASKID__
}
